module.exports = __webpack_public_path__ + "static/media/OAU.b8f22a23.jpg";